var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOffline)?_c('div',{staticClass:"offline-indicator"},[_c('div',{staticClass:"wrapper"},[_c('p',{staticClass:"offline-indicator__text"},[_vm._v(" "+_vm._s(_vm.$t('You are offline, the data shown can be outdated.'))+" ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }